import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import theme from 'site-react/theme';

const imageContainerStyle = css`
  background-clip: content-box;
  border: 3px solid transparent;
  border-radius: 50%;
  box-shadow: 0 0 0 transparent;
  margin: ${theme.spacing.base / 2}px;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
`;

const imageContainerHoverStyle = css`
  &:hover {
    box-shadow: 0 0 0 2px ${theme.colors.brandPrimary};
    cursor: pointer;
  }
`;

const imageStyle = css`
  width: 100%;
  height: 100%;
`;

const wrapperStyle = css`
  box-sizing: border-box;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
`;

/* NOTE: We have two containers here to fix the cross browser hover issue
Firefox has some rendering issues due to the transform property,
we use it to vertical align our navbar */
const AccountIconImg = ({ alt, hover, size, src }) => {
  const baseSrc = `${src}${
    src.includes('?') ? '&' : '?'
  }h=${size}&w=${size}&fit=crop&crop=faces&fm=png32&auto=format&lossless=true`;

  return (
    <div
      className={cx(
        wrapperStyle,
        css`
          width: ${size + 10}px;
          height: ${size + 10}px;
        `,
      )}
      data-testid="account-icon"
      size={size}
    >
      <div
        className={cx(
          imageContainerStyle,
          hover && imageContainerHoverStyle,
          css`
            width: ${size + 6}px;
            height: ${size + 6}px;
          `,
        )}
      >
        <img
          className={imageStyle}
          src={baseSrc}
          srcSet={`${baseSrc} 1x, ${baseSrc}&dpr=2 2x`}
          alt={alt}
        />
      </div>
    </div>
  );
};

AccountIconImg.propTypes = {
  /**
   * Alt text to show
   */
  alt: PropTypes.string.isRequired,

  /**
   * Should this icon have a special style on hover?
   */
  hover: PropTypes.bool.isRequired,

  /**
   * Width and height of this icon, in pixels.
   */
  size: PropTypes.number.isRequired,

  /**
   * The source path of the icon.
   */
  src: PropTypes.string.isRequired,
};

export default AccountIconImg;
